import { createStore } from 'vuex'

export default createStore({
  state: {
    userinfo:'',
  },
  getters: {
  },
  mutations: {
    saveUserInfo(state,param){
      console.log(param)
      state.userinfo=param;
    }
  },
  actions: {
  },
  modules: {
  }
})
